import { render, staticRenderFns } from "./MEventPopup.vue?vue&type=template&id=2ba23c26&scoped=true"
import script from "./MEventPopup.vue?vue&type=script&lang=js"
export * from "./MEventPopup.vue?vue&type=script&lang=js"
import style0 from "./MEventPopup.vue?vue&type=style&index=0&id=2ba23c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba23c26",
  null
  
)

export default component.exports